import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { getFileViewerTranslations } from '../../constants/file-viewer.translations';
import { downloadFile, filenameFromPath, openFileInNewTab, safeDecodeURIComponent } from '../../utils/file-viewer.utils';

@Component({
  selector: 'app-file-viewer-pdf',
  imports: [CommonModule],
  templateUrl: './file-viewer-pdf.component.html',
  styleUrl: './file-viewer-pdf.component.scss',
})
export class FileViewerPdfComponent {
  @Input() isComponent = false;
  @Input() src: string | null = null;
  @Input() name: string | null = null;
  @Input() languageCode = 'it';

  pdfUrl: string | null = null;
  safePdfUrl: SafeResourceUrl | null = null;
  pdfTitle = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {}

  get translations() {
    return getFileViewerTranslations(this.languageCode);
  }

  ngOnInit(): void {
    this._resolvePdfSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] || changes['name']) {
      this._resolvePdfSource();
    }
  }

  download(): void {
    if (!this.pdfUrl) {
      return;
    }

    downloadFile(this.pdfUrl, this.pdfTitle || this.translations.pdfFallbackTitle);
  }

  openInNewTab(): void {
    if (!this.pdfUrl) {
      return;
    }

    openFileInNewTab(this.pdfUrl);
  }

  private _resolvePdfSource(): void {
    const explicitSrc = this.src;
    const explicitName = this.name;
    const rawName = this.route.snapshot.paramMap.get('name');
    const raw = this.route.snapshot.paramMap.get('src');
    const decodedName = rawName ? safeDecodeURIComponent(rawName) : null;
    const decoded = raw ? safeDecodeURIComponent(raw) : null;

    if (explicitSrc) {
      this.pdfUrl = explicitSrc;
      this.pdfTitle = explicitName || filenameFromPath(explicitSrc);
    } else if (decoded) {
      this.pdfUrl = decoded;
      this.pdfTitle = decodedName || filenameFromPath(decoded);
    } else {
      this.pdfUrl = null;
      this.pdfTitle = '';
    }

    this.safePdfUrl = this.pdfUrl
      ? this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl)
      : null;
  }
}
